import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { ChartQueryParams, HeatmapChartData } from '@frontend/chart/types';

export class SlotChartClient extends APIClient {
    public static readonly endpoint = '/slot-api/v1';

    public static async fetchOccupiedSlots(
        accountId: string,
        spotId: string,
        moduleId: string,
        queryParams?: ApiQueryParams<ChartQueryParams>
    ): Promise<HeatmapChartData> {
        const response = await this.fetchWithQueryParams(
            `${this.endpoint}/accounts/${accountId}/spots/${spotId}/modules/${moduleId}/occupied-slots`,
            undefined,
            true,
            undefined,
            queryParams
        );
        return await this.handleResponse<HeatmapChartData>(response);
    }
}
